export enum REFERRER {
    gotoAdmin = 'gotoadmin',
}

export const REFERRER_QUERY_PARAM = 'referrer'
